import api from './api';
import { apiPath } from '../config/apiConfig';
import { ApplicationDelegate, CreateDelegationRequest, UpdateDelegationRequest } from '../types';

export const delegationAPI = {
  // Get all delegates for an application
  getApplicationDelegates: async (applicationId: string): Promise<ApplicationDelegate[]> => {
    const response = await api.get(apiPath(`/delegation/application/${applicationId}`));
    return response.data.data;
  },

  // Get all delegates for a user
  getUserDelegates: async (userId: string): Promise<ApplicationDelegate[]> => {
    const response = await api.get(apiPath(`/delegation/user/${userId}`));
    return response.data.data;
  },

  // Create a new delegation
  createDelegation: async (delegationData: CreateDelegationRequest): Promise<ApplicationDelegate> => {
    const response = await api.post(apiPath('/delegation'), delegationData);
    return response.data.data;
  },

  // Update a delegation
  updateDelegation: async (id: string, updates: UpdateDelegationRequest): Promise<ApplicationDelegate> => {
    const response = await api.put(apiPath(`/delegation/${id}`), updates);
    return response.data.data;
  },

  // Delete a delegation
  deleteDelegation: async (id: string): Promise<void> => {
    await api.delete(apiPath(`/delegation/${id}`));
  },

  // Revoke a delegation
  revokeDelegation: async (id: string): Promise<ApplicationDelegate> => {
    const response = await api.patch(apiPath(`/delegation/${id}/revoke`));
    return response.data.data;
  },

  // Check if user is delegated to application
  checkDelegation: async (applicationId: string, userId: string): Promise<{ isDelegated: boolean }> => {
    const response = await api.get(apiPath(`/delegation/check/${applicationId}/${userId}`));
    return response.data.data;
  }
};

export default delegationAPI;
